/* eslint max-classes-per-file: 0 */

import {
  UserParticipantsCollection as Data,
  UserParticipantsCollection as Collection,
} from '@/typings/api/User'
import { UsersParticipantsApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class UsersParticipantsTransformerParams extends TransformerParams {
  protected defaultParams = ['user_id'];
}

export class UsersParticipantsAdapter extends Adapter<Api> {
  public readonly api = new Api();

  public readonly transformerParams = new UsersParticipantsTransformerParams();
}
